import { render } from "./UserLayout.vue?vue&type=template&id=50f38181&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"

import "../../public/assets/cssLanding/bootstrap.min.css?vue&type=style&index=0&id=50f38181&scoped=true&lang=css&external"
import "../../public/assets/cssLanding/bootstrap.min.css?vue&type=style&index=1&id=50f38181&scoped=true&lang=css&external"
import "../../public/assets/fontsLanding/iconfonts.css?vue&type=style&index=2&id=50f38181&scoped=true&lang=css&external"
import "../../public/assets/cssLanding/plugins.css?vue&type=style&index=3&id=50f38181&scoped=true&lang=css&external"
import "../../public/assets/cssLanding/style.css?vue&type=style&index=4&id=50f38181&scoped=true&lang=css&external"
import "../../public/assets/cssLanding/responsive.css?vue&type=style&index=5&id=50f38181&scoped=true&lang=css&external"
import "../../public/assets/cssLanding/color.css?vue&type=style&index=6&id=50f38181&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f38181"]])

export default __exports__